import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
import { V_URL } from "../../../../BaseUrl";

export const getIssuePiece = createAsyncThunk(
    '/user/get-issued-piece',
    async (payload) => {
        try {
            const myurl = `${V_URL}/prosafe/get-issued-piece`;
            const response = await axios({
                method: 'post',
                url: myurl,
                data: payload,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN')
                },
            });

            const lotData = response.data;

            if (lotData.success === true) {
                return lotData;
            } else {
                throw new Error(lotData);
            }
        } catch (error) {
            toast.error(error.response.data.message);
            return error;
        }
    }
);

const getIssuePieceSlice = createSlice({
    name: "getIssuePiece",
    initialState: {
        user: null,
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getIssuePiece.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getIssuePiece.fulfilled, (state, action) => {
                state.user = action.payload;
                state.loading = false;
                state.error = null;
            })
            .addCase(getIssuePiece.rejected, (state, action) => {
                state.user = null;
                state.loading = false;
                state.error = action.error.message;
            });
    }
})

export default getIssuePieceSlice.reducer;